import { Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ContactInformationsItemComponent } from './contact-informations-item/contact-informations-item.component';
import { LinkComponent } from '@atoms/link/link.component';
import { SmallComponent } from '@atoms/small/small.component';
import { PhonePipe } from '@pipes/phone.pipe';

@Component({
  selector: 'app-contact-informations',
  imports: [TranslateModule, ContactInformationsItemComponent, LinkComponent, SmallComponent, PhonePipe],
  templateUrl: './contact-informations.component.html',
  styleUrl: './contact-informations.component.scss',
})
export class ContactInformationsComponent {}
